import store from '@/store/store';
import genererGuid from '@/services/general/genererGuid';
import adresseGenerer, { formatAdresseConcurrent } from '@/services/general/genererAdresse';
import genererModeReglement from '@/services/devis/genererModeReglement';
import genererDelaiReglement from '@/services/devis/genererDelaiReglement';
import genererDelaiReglementDetail from '@/services/devis/genererDelaiReglementDetail';
import genererModeCalculHonoraire from '@/services/devis/genererModeCalculHonoaire';
import { APPLICATION_TVA_TYPE_NORMAL } from '@/configuration/applicationTvaConf';
import * as config from '@/configuration/clientConf';

export default function generer() {
  const adressePostale = adresseGenerer();
  const adresseFacturation = adresseGenerer();
  const modeReglement = genererModeReglement();
  const delaiReglement = genererDelaiReglement();
  const delaiReglementDetail = genererDelaiReglementDetail();
  return {
    guid: genererGuid(),
    nomCommercial: '',
    nomJuridique: '',
    siret: '',
    siren: '',
    ape: '',
    tvaIntracommunautaire: '',
    secteurActiviteId: null,
    telephone: '',
    portable: '',
    email: '',
    siteWeb: '',
    marque: '',
    adressePostale: adressePostale,
    adresseFacturation: adresseFacturation,
    contacts: [],
    rib: {
      banque: '',
      iban: '',
      bic: '',
      titulaire: '',
    },
    modeReglementId: null,
    modeReglement: modeReglement,
    delaiReglementId: null,
    delaiReglement: delaiReglement,
    delaiReglementDetail: delaiReglementDetail,
    compteComptable: '',
    commentairesBonDeCommandes: '',
    commentairesFacturation: '',
    commentairesInternes: '',
    blocageReglement: false,
    motifBlocageId: null,
    piecesJointes: [],
    adresseFacturationDifferente: false,
    archive: false,
    nombreJourDecalage: null,
    finDeMois: null,
    jourFinDeMois: null,
    companyId: 0,
    typologie: config.TYPOLOGIE_AUCUN,
    tiersParentId: null,
    prenom: null,
    nom: null,
    sousTypes: null,
    type: null,
    typePointVenteId: null,
    codeMagasin: null,
    factureParMail: false,
    applicationTva: APPLICATION_TVA_TYPE_NORMAL,
    prospect: false,
    role: null,
    portail: false,
    nombreMoisPreavis: null,
    modeCalculHonoraire: genererModeCalculHonoraire(),
    referenceUniqueMandat: null,
    moisDebutPeriodeBudgetaire: null,
    moisFinPeriodeBudgetaire: null,
    dateSignatureMandatSepa: null,
    estMairie: true,
    dateNaissance: null,
    nomJeuneFille: null,
    pourcentageRetrocession: null,
    referenceExterne: null,
    domTom: false,
    numeroCedant: '',
    numeroFichier: null,
    tiersMarques: [],
    lieuStockage: false,
    commentaireFactor: '',
    dateAnniversaireContrat: null,
    factorId: null,
    tags: [],
    competencesFournisseur: [],
    secteur: [],
    referenceHavas: null,
  };
}

export function genererPointDeVente() {
  const tiers = generer();
  tiers.typologie = config.POINT_VENTE;
  tiers.sousTypes = [config.SOUS_TYPE_AUCUN];
  tiers.srcImg = '';
  tiers.icon = '';
  return tiers;
}

export function genererConcurrents(data) {
  const societeId = store.getters['societe/societeActiveId'];
  if (data.length === 0) return data;
  return data.map(el => ({
    ...generer(),
    nomCommercial: el.name,
    adressePostale: formatAdresseConcurrent(el),
    societeId: societeId,
    typologie: config.POINT_VENTE,
    tiersParentId: el.enseigneId,
    secteurActiviteId: el.secteurActiviteId,
    tiersMarques: el.tiersMarques,
    marque: el.marque,
    type: config.TYPE_CLIENT,
    sousTypes: [config.SOUS_TYPE_CONCURRENT],
  }));
}
